import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { motion } from 'framer-motion';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to JBR Delivery LLC's homepage." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <Box
        sx={{
          bgcolor: 'background.paper',
          py: 10,
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Container maxWidth="md">
          <Box textAlign="center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Typography
                variant="h1"
                component="h1"
                color="primary"
                sx={{ 
                  fontWeight: 900, 
                  fontSize: { xs: '6rem', md: '10rem' },
                  lineHeight: 1,
                  mb: 2,
                }}
              >
                404
              </Typography>
              
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{ 
                  fontWeight: 700,
                  mb: 3,
                }}
              >
                Page Not Found
              </Typography>
              
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ 
                  maxWidth: '600px',
                  mx: 'auto',
                  mb: 5,
                }}
              >
                The page you're looking for might have been removed, had its name changed, or is temporarily unavailable. Please check the URL or return to our homepage.
              </Typography>
              
              <Button
                variant="contained"
                color="primary"
                size="large"
                component={RouterLink}
                to="/"
                startIcon={<ArrowBackIcon />}
                sx={{ px: 4, py: 1.5, fontWeight: 600 }}
              >
                Back to Home
              </Button>
            </motion.div>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NotFoundPage;
